import { useSupabaseTable } from './useSupabaseTable';

export function useServicos() {
  return useSupabaseTable('servicos', { orderBy: 'codigo', ascending: true });
}
